// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { STATE } from '../../../common/constant'
import { post } from '../../api'

export const actionState = createAsyncThunk('appState/actionState', async (params, thunkAPI) => {
    return await post(STATE, params, thunkAPI)
})

export const appStateSlice = createSlice({
    name: 'appState',
    initialState: {
        //list
        loading: false,
        state: null
    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetStateResponse: (state) => {
            state.state = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionState.pending, (state) => {
                state.loading = true
            })
            .addCase(actionState.fulfilled, (state, action) => {
                state.loading = false
                state.state = action.payload
            })
            .addCase(actionState.rejected, (state) => {
                state.loading = false
            })
    }
})
export const { resetStateResponse } = appStateSlice.actions

export default appStateSlice.reducer